import FusionInputField from 'components/FusionInputField/FusionInputField';
import React, { useEffect, useState } from 'react';
import styles from '../AudioRecorder.module.css';
import FusionInputSlider from 'components/FusionSlider/FusionInputSlider';
import { MSToTimeString } from 'utils/stringUtils';
import { IoPlay, IoRefresh, IoStop } from 'react-icons/io5';
import { PiMicrophoneFill } from 'react-icons/pi';
import { BsStopFill, BsUpload } from 'react-icons/bs';
import { FaUpload } from 'react-icons/fa';
import useDebounce from 'hooks/useDebounce';

const MODES = ['idle', 'recording', 'upload-ready'];

export default function RecordNew({
  duration,
  maxDuration,
  fileName,
  recording,
  playing,
  errMsg,
  onFileNameChange = () => {},
  toggleRecording = () => {},
  onClear = () => {},
  onUpload = () => {},
  onPlayback = () => {},
  onStopPlayback = () => {},
}) {
  const [mode, setMode] = useState(MODES[0]);

  useEffect(() => {
    if (recording) setMode(MODES[1]);
    else if (mode !== MODES[0]) setMode(MODES[2]);
  }, [recording, mode]);

  const onClearInt = () => {
    setMode(MODES[0]);
    onClear();
  };

  return (
    <div className="flex-fill d-flex flex-column justify-content-center align-items-stretch px-2">
      <div className="text-center">
        {mode === MODES[0] && <p>Press microphone to begin recording.</p>}
        {mode === MODES[1] && <p>Recording...</p>}
        {mode === MODES[2] && <p>Finished Recording.</p>}
      </div>

      <div className="d-flex flex-column align-items-stretch">
        <div className="progress flex-fill bg-primary border" style={{ height: '20px' }}>
          <div
            className="progress-bar bg-white"
            style={{ width: `${(duration / maxDuration) * 100}%` }}
          />
        </div>

        <div className="flex-fill text-center mt-2">
          {mode === MODES[2] && (
            <FusionInputField
              type="text"
              placeholder="File Name"
              value={fileName}
              onChange={onFileNameChange}
            />
          )}

          <p>
            {MSToTimeString(duration)} / {MSToTimeString(maxDuration)}
          </p>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        {mode === MODES[0] && (
          <button className="btn btn-primary" onClick={() => toggleRecording(maxDuration)}>
            <PiMicrophoneFill size={25} />
          </button>
        )}

        {mode === MODES[1] && (
          <button className="btn btn-primary" onClick={() => toggleRecording(maxDuration)}>
            <BsStopFill size={25} />
          </button>
        )}

        {mode === MODES[2] && (
          <div className="d-flex w-100 justify-content-center justify-content-sm-between">
            <div className="d-flex">
              <button className="btn btn-primary" onClick={onClearInt}>
                <IoRefresh size={25} />
              </button>

              {!playing && (
                <button className="btn btn-primary" onClick={onPlayback}>
                  <IoPlay size={25} />
                </button>
              )}

              {playing && (
                <button className="btn btn-primary" onClick={onStopPlayback}>
                  <IoStop size={25} />
                </button>
              )}
            </div>

            {errMsg && <p data-error>{errMsg}</p>}

            <div>
              <button className="btn btn-primary" onClick={onUpload}>
                <span>
                  <FaUpload size={25} />
                </span>{' '}
                Upload
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
